import { useState } from "react";

export const useSelectField = () => {
  const [isFocused, setIsFocused] = useState(false);

  const onFocus = () => {
    setIsFocused(true);
  };

  const onBlur = () => {
    setIsFocused(false);
  };

  return {
    isFocused,
    setIsFocused,
    onFocus,
    onBlur,
  };
};
